import FaxUnsubscribe from '../../pages/fax/public/FaxUnsubscribe';

const publicRoutes = [
  {
    path: '/fax/unsubscribe',
    name: 'fax_unsubscribe',
    component: FaxUnsubscribe,
    meta: {
      layout: 'public',
    },
  }
]

export default publicRoutes;
